import React, { useEffect, useRef, useState } from "react";
import {
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { quickpay } from "../model/e_quick-pay-action";
import { quickpayService } from "../model/e_quick-pay-service";
import { routePaths } from "../../../config/route-paths";
import { history } from "../../../../helpers/index";
import { Alert, Skeleton } from "@material-ui/lab";
import {config} from '../../../../enviroment';
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
export const TextFiled = withStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-input": {
      paddingTop: "0.75rem !important",
      paddingBottom: "0.75rem !important",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base
    },
    "& .MuiInput-underline.Mui-error:after": {
    borderBottomColor: theme.palette.eDanger?.dark
    } 
  },
}))(TextField);

const useStyles = makeStyles((theme) => ({
  submitButton: {
    backgroundColor: theme.palette.ePrimary.base + " !important",
    marginTop: "0.625rem",
    color: theme?.palette?.eWhite?.base + " !important",
    borderRadius: "1.25rem",
    padding: "0.3rem 1.5rem",
    "&:hover": {
      backgroundColor: theme?.palette?.ePrimary.hover + " !important",
      color: theme?.palette?.eWhite?.base + " !important"
    }
  },
  whiteColor: {
    color: theme?.palette?.eWhite?.base + " !important",
  },
  mandetoryFieldStyling: {
    color: theme?.palette?.eDanger?.dark
  },
  disabledBtn:{
    marginTop: "0.625rem",
    background: theme.palette.eLight.base+"!important",
    borderRadius: "1.25rem",
    padding: "0.3rem 1.5rem",
  },
  idColor:{
    color:theme.palette.eRich.base
  },
  errorStyle:{
    color:theme.palette.eDanger.dark,
    backgroundColor:theme.palette.eDanger.light,
    marginTop:"2%"
  },
  accountIdFont:{
    '& .MuiInputBase-root':{
      fontSize:"0.875rem"
    }
  }
}));

export default function AccountInput() {
  const dispatch = useDispatch();
  let classes = useStyles();
  const captchaRef=useRef()
  const siteKey = config.recaptcha.SITE_KEY
  const [captcha, setCaptcha] = useState("");
  let [err, setErr] = useState(false);
  let [isLoading, setLoading] = useState(false);
  let only_digits_regex = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.ONLY_DIGITS_REGEX
  );
  let enableCaptcha = useSelector((store)=>store?.parametersWidgets.ParameterLookup?.ENABLE_CAPTCHA)
  // let labels = useSelector(
  //   (state) => state?.labels?.data?.getLabels?.E_QUICK_PAY
  // );
  const {t:labels, ready: labelsReady} = useTranslation("label-E_QUICK_PAY")
  let uniqueId = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER
  );
  
  const {t:label, ready: labelReady} = useTranslation("label-NESCO_Customer_No_label")
  let accountIdLength=useSelector(
    (state)=>state?.parametersWidgets?.ParameterLookup?.E_ACCOUNT_NUMBER_LENGTH
  )
  const [accountId, setAccountId] = useState('');
  const [accountIdRequired,setAccountIdRequired]=useState(false);
  const [accountIdError,setAccountIdError]=useState(false)
  const [disabled,setDisabled]=useState(true)
  let E_CUSTOMER_NO_LENGTH=useSelector(
  (state) => state?.parametersWidgets?.ParameterLookup?.E_CUSTOMER_NO_LENGTH
);
  useEffect(()=>{
    if(accountId.length === 0 || accountId.length < accountIdLength){
      setDisabled(true)
    }else if ( accountId.length === Number(accountIdLength) && captcha.value &&
    captcha.value !== null){
      setDisabled(false)
    }
    else{
      setDisabled(true)
    }
  },[accountIdLength,accountId,captcha])

  useEffect(()=>{
    if(accountId.length > accountIdLength){
      setAccountIdError(true)
    }else{
      setAccountIdError(false)
    }
  },[accountIdLength,accountId])

  useEffect(() => {
    if (disabled === false) {
      setDisabled(true);
    }
    setTimeout(() => {
      setCaptcha({ ...captcha, load: true });
    }, 500);
  }, []);

  function handleChange(e) {
    setErr(false);
    setAccountIdError(false);
    const re = new RegExp(only_digits_regex);
    if (e.target.value === "" || re.test(e.target.value)) {
      setAccountId(e.target.value);
    }
  }
  const keypress = (event) => {
    if (event.key === "Enter") {
      handleClickSubmit(event);
    }
  };

  let accountIdBlur=()=>{
    if(accountId){  
      setAccountIdRequired(false)
    }else{
      setAccountIdRequired(true)
    }
  }

  const captchaHandleExpired=(value)=>{
    captchaRef.reset();
  }


  const captchaAsyncScriptOnLoad = () => {
    setCaptcha({
      ...captcha,
      callback: "called!",
    });
  };


  const captchaHandleChange = (value) => {
    setCaptcha({
      ...captcha,
      value: value,
    });
    if (value !== null && Number(accountIdLength) === accountId.length)
      setDisabled(false);
    if (value === null)
      setCaptcha({
        ...captcha,
        expired: true,
      });
  };

  
  const handleClickSubmit = (e) => {
    accountIdBlur()
    if (accountId && !disabled) {
      if(!accountIdRequired){
      setLoading(true);
      localStorage.setItem("accountId", accountId);
      quickpayService
        .postbalance(uniqueId, accountId)
        .then((res) => {
          setLoading(false);
          dispatch(quickpay(res));
          history.push(routePaths.VIEW_BALANCE);   
        })
        .catch((err) => {
          setLoading(false);
          err?.response?.status === 400 ? 
          setErr(config?.quickpayConstants?.INVALID_ACC_ID_LABEL_KEY) : 
          setErr(config?.quickpayConstants?.INTERNAL_ERR_MSG_LABEL_KEY);
          setAccountIdError(true);
        });
    }
    }
  };

  return (
    <>
      <br />
      {
        labelReady?
      <Typography variant="subtitle2" className={classes.idColor}>
      {label("N_CUSTOMER_NUMBER")} <span className={classes.mandetoryFieldStyling}>*</span>
      </Typography>
      : <Skeleton />
      }
      <TextFiled
        fullWidth
        onBlur={accountIdBlur}
        className={classes.accountIdFont}
        name="accountId"
        value={accountId}
        onChange={handleChange}
        inputProps={{
          maxLength: Number(parseInt(E_CUSTOMER_NO_LENGTH)),
        }}
        placeholder={label("N_QUICK_PAY_CONNECTION_ID_PLACEHOLDER")}
        onKeyPress={keypress}
        error={accountIdRequired || accountIdError || err}
        helperText={
          accountIdRequired
            ? label("N_QUICK_PAY_CONNECTION_ID_REQUIRED")
            : 
            accountIdError?
              label("N_QUICK_PAY_CONNECTION_ID_NOT_VALID") 
            : err ? labels?.[err] :
            null
        }
      />
      <br/>
      <br/>
      {captcha.load && enableCaptcha && (
        <ReCAPTCHA
          style={{ display: "inline-block" }}
          theme="light"
          ref={captchaRef}
          sitekey={siteKey}
          onChange={captchaHandleChange}
          asyncScriptOnLoad={captchaAsyncScriptOnLoad}
          size="normal"
          onExpired={captchaHandleExpired}
        />)
      }
      <br/>
      <Button
        type="submit"
        variant="contained"
        className={disabled ? classes.disabledBtn : classes.submitButton}
        onClick={handleClickSubmit}
        disabled={disabled}
      >
         {labels("E_BUTTON_SUBMIT")} &nbsp;
        {isLoading ? (
          <CircularProgress size={18} className={classes.whiteColor} />
        ) : (
          " "
        )}
      </Button>
      <br />
      <br />
    </>
  );
}